
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface FormHeaderProps {
  title: string;
  backPath?: string;
}

const FormHeader = ({ title, backPath = "/agents" }: FormHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center mb-6">
      <Button variant="ghost" onClick={() => navigate(backPath)} className="mr-2">
        <ArrowLeft className="h-4 w-4 mr-1" />
        Back to Agents
      </Button>
      <h1 className="font-bold">{title}</h1>
    </div>
  );
};

export default FormHeader;
